module.exports = __webpack_public_path__ + "static/media/BAAllSelected.77b8c8a0.svg";